import {
  SET_CRONJOB_TIMER_ID,
  START_CRONJOB,
  STOP_CRONJOB,
  stopCronJob
} from '../actions/cronJobs';
import { gae } from '../../components/helpers/Analytics';
import {
  beginCronPollTick,
  endCronPollTick,
  flushLastCronPollSpans
} from '../../telemetry/pollQuiet';

function maybeStopByCancelResult(dispatch, jobId, jobResult) {
  if (jobResult === -1) {
    gae('CRON_JOB', 'STOP_BY_JOB_CANCEL_RESULT');
    dispatch(stopCronJob(jobId));
  }
}

/**
 * Status polls often return a Promise (XHR starts after the sync wrapper).
 * Keep poll-quiet until the Promise settles so Fetch/XHR spans are held.
 */
function runCronTickQuiet(dispatch, job) {
  beginCronPollTick();
  let settled = false;
  const finishQuiet = () => {
    if (settled) return;
    settled = true;
    endCronPollTick();
  };

  let jobResult;
  try {
    jobResult = job.doJob();
  } catch (e) {
    finishQuiet();
    throw e;
  }

  if (jobResult && typeof jobResult.then === 'function') {
    jobResult.then(
      result => {
        finishQuiet();
        maybeStopByCancelResult(dispatch, job.id, result);
      },
      () => {
        finishQuiet();
      }
    );
    return;
  }

  finishQuiet();
  maybeStopByCancelResult(dispatch, job.id, jobResult);
}

function createCronJob(dispatch, job) {
  const startTime = new Date().getTime();

  gae('CRON_JOB', 'CREATE', job.id);

  return setInterval(() => {
    if (
      job.timeOut &&
      (new Date().getTime() - startTime) / 1000 > job.timeOut
    ) {
      // Final timeout call — full telemetry (not poll-quiet).
      gae('CRON_JOB', 'STOP_BY_TIMEOUT');
      job.doJob(true);
      dispatch(stopCronJob(job.id));
      return;
    }

    // Intermediate / status polls: hold spans; only last tick is flushed on stop.
    runCronTickQuiet(dispatch, job);
  }, job.period);
}

export const cronJobs = store => next => action => {
  const prevState = store.getState();
  const result = next(action);
  const nextState = store.getState();
  const dispatch = store.dispatch;

  switch (action.type) {
    case START_CRONJOB: {
      const job = nextState.cronJobs.get(action.cronJob.id);
      dispatch({
        type: SET_CRONJOB_TIMER_ID,
        id: job.id,
        timerId: createCronJob(dispatch, job)
      });
      break;
    }
    case STOP_CRONJOB: {
      const job = prevState.cronJobs.get(action.id);
      if (job) {
        clearInterval(job.timerId);
      }
      // Keep only the last poll’s HTTP/spans in the session trace.
      flushLastCronPollSpans();
      break;
    }
    default:
  }

  return result;
};
